import { render, staticRenderFns } from "./Servicetype.vue?vue&type=template&id=3fad5170"
import script from "./Servicetype.vue?vue&type=script&lang=js"
export * from "./Servicetype.vue?vue&type=script&lang=js"
import style0 from "./Servicetype.vue?vue&type=style&index=0&id=3fad5170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports